/* Simulated device controls; no media permissions or operating system actions. */
(function () {
  if (customElements.get('muteme-click-playground')) return;
  customElements.define('muteme-click-playground', class extends HTMLElement {
    connectedCallback() {
      if (!this.isConnected || this.initialized) return;
      if (!this.querySelector('[data-click-demo-end]')) {
        this.frame = requestAnimationFrame(() => this.connectedCallback()); return;
      }
      this.initialized = true;
      this.timers = new Set();
      this.output = this.querySelector('.click-demo-result');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.addEventListener('click', event => this.onClick(event), options);
      this.addEventListener('change', event => this.onChange(event), options);
      window.addEventListener('blur', () => this.clearTransientFeedback(), options);
      window.addEventListener('pagehide', () => this.clearTransientFeedback(), options);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.clearTransientFeedback();
      }, options);
      this.resetAll();
      this.querySelector('fieldset').disabled = false;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.clearTransientFeedback();
      if (this.events) this.events.abort();
      this.initialized = false;
    }
    clearTransientFeedback() {
      if (this.timers) { this.timers.forEach(clearTimeout); this.timers.clear(); }
      this.querySelectorAll('.pg-pressed').forEach(button => button.classList.remove('pg-pressed'));
      const screen = this.querySelector('.pg-screen');
      const toast = this.querySelector('.pg-screen-toast');
      if (screen) screen.classList.remove('pg-flash');
      if (toast) toast.hidden = true;
    }
    later(callback, delay) {
      const id = setTimeout(() => { this.timers.delete(id); callback(); }, delay);
      this.timers.add(id); return id;
    }
    say(message) { this.output.textContent = message; }
    toast(message) {
      const toast = this.querySelector('.pg-screen-toast');
      clearTimeout(this.toastTimer); this.timers.delete(this.toastTimer);
      toast.textContent = message; toast.hidden = false;
      this.toastTimer = this.later(() => { toast.hidden = true; }, 2200);
    }
    resetAll() {
      this.clearTransientFeedback();
      this.querySelector('.pg-color-editor').open = false;
      this.palette = { '#c10000': 'Red', '#4caf50': 'Green', '#2196f3': 'Blue', '#ffeb00': 'Yellow', '#00bcd4': 'Cyan', '#b45af5': 'Purple', '#f0f0f0': 'White', '#000000': 'Off' };
      this.settings = { meeting: {}, idle: {} };
      ['cameraOn', 'cameraOff', 'micOn', 'micOff'].forEach(key => {
        this.settings.meeting[key] = { color: key.endsWith('On') ? '#4caf50' : '#c10000', effect: 'bright' };
        this.settings.idle[key] = { color: '#f0f0f0', effect: 'dim' };
      });
      this.progress = new Set(); this.volume = 50; this.shots = 0; this.commands = 0;
      this.querySelector('[data-command]').value = 'Launch focus mode';
      this.querySelector('.pg-screen-toast').hidden = true;
      this.querySelector('.pg-screen').classList.remove('pg-flash');
      this.querySelectorAll('.pg-pressed').forEach(button => button.classList.remove('pg-pressed'));
      this.setPreset('meeting'); this.selectChannel('camera'); this.startCall(); this.renderColors();
      this.say('You’re in the demo call. Click the device, set your colors, and make it yours.');
    }
    startCall() {
      this.inCall = true; this.mic = true; this.camera = false; this.hand = false; this.sharing = false;
      this.render();
    }
    onClick(event) {
      const button = event.target.closest('button');
      if (!button || !this.contains(button) || button.disabled) return;
      if (button.dataset.channel) { this.selectChannel(button.dataset.channel); return; }
      if (button.dataset.colorKey) { this.setColor(button.dataset.mode, button.dataset.colorKey, button.dataset.color); return; }
      if (button.dataset.effectKey) {
        const setting = this.settings[button.dataset.mode]?.[button.dataset.effectKey];
        if (!setting || setting.color === '#000000' || !['bright', 'dim', 'pulse'].includes(button.dataset.effectValue)) return;
        setting.effect = button.dataset.effectValue;
        this.mark('color'); this.renderColors(); this.render();
        this.say((button.dataset.mode === 'meeting' ? 'Meeting' : 'Idle') + ' lighting set to ' + button.textContent.toLowerCase() + '.'); return;
      }
      if (button.dataset.preset) {
        this.setPreset(button.dataset.preset);
        this.say(button.textContent.trim() + ' selected. Try the dot buttons on the device.'); return;
      }
      const action = button.dataset.action;
      if (!action) return;
      if (button.classList.contains('click-demo-key')) {
        button.classList.add('pg-pressed'); this.later(() => button.classList.remove('pg-pressed'), 200);
      }
      if (action === 'reset') { this.resetAll(); return; }
      if (action === 'rejoin' || action === 'join') { this.startCall(); this.say('Back in a meeting. Your call colors are active.'); return; }
      if (action === 'leave') { this.endCall(); return; }
      if (action === 'custom1' || action === 'custom2') {
        const number = action === 'custom1' ? '1' : '2';
        this.mark('shortcut');
        this.runAction(this.querySelector('[data-map="' + number + '"]').value); return;
      }
      this.runAction(action);
    }
    onChange(event) {
      const target = event.target;
      if (target.matches('select[data-map]')) {
        this.syncMappingLabels();
        this.querySelectorAll('[data-preset]').forEach(button => button.setAttribute('aria-pressed', 'false'));
        this.say((target.dataset.map === '1' ? 'One-dot' : 'Two-dot') + ' button mapped to ' + target.options[target.selectedIndex].text.toLowerCase() + '. Give it a click.');
      } else if (target.matches('[data-effect]')) {
        const setting = this.settings[target.dataset.mode]?.[target.dataset.effect];
        if (!setting || setting.color === '#000000' || !['bright', 'dim', 'pulse'].includes(target.value)) return;
        setting.effect = target.value;
        this.mark('color'); this.renderColors(); this.render();
        this.say((target.dataset.mode === 'meeting' ? 'Meeting' : 'Idle') + ' lighting effect updated.');
      }
    }

    selectChannel(channel) {
      this.querySelectorAll('[data-channel]').forEach(button => {
        const selected = button.dataset.channel === channel;
        button.setAttribute('aria-selected', String(selected)); button.tabIndex = selected ? 0 : -1;
        button.onkeydown = event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 'camera' : event.key === 'End' ? 'mic' : (channel === 'camera' ? 'mic' : 'camera');
          this.selectChannel(next); this.querySelector('[data-channel="' + next + '"]').focus();
        };
      });
      this.querySelectorAll('[data-color-panel]').forEach(panel => { panel.hidden = panel.dataset.colorPanel !== channel; });
    }
    setColor(mode, key, color) {
      if (!this.settings[mode]?.[key] || !Object.prototype.hasOwnProperty.call(this.palette, color)) return;
      this.settings[mode][key].color = color;
      this.mark('color'); this.renderColors(); this.render();
      const labels = { cameraOn: 'Camera on', cameraOff: 'Camera off', micOn: 'Microphone live', micOff: 'Microphone muted' };
      const context = mode === 'meeting' ? 'in a meeting' : 'not in a meeting';
      this.say(labels[key] + ' when ' + context + ': ' + this.palette[color] + (color === '#000000' ? '. Lights off; effects are disabled.' : '. Your preference is saved in this preview.'));
    }
    renderColors() {
      const defaults = ['cameraOn', 'cameraOff', 'micOn', 'micOff'].every(key => {
        const meeting = this.settings.meeting[key], idle = this.settings.idle[key];
        return meeting.color === (key.endsWith('On') ? '#4caf50' : '#c10000') && meeting.effect === 'bright' && idle.color === '#f0f0f0' && idle.effect === 'dim';
      });
      this.querySelector('.pg-colors-summary').textContent = defaults ? 'Red/green in meetings · Dim white when idle' : 'Your custom lighting setup';
      ['meeting', 'idle'].forEach(mode => {
        Object.entries(this.settings[mode]).forEach(([key, setting]) => {
          this.querySelector('[data-color-value="' + mode + '-' + key + '"]').textContent = this.palette[setting.color];
          this.querySelectorAll('[data-color-key="' + key + '"][data-mode="' + mode + '"]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.color === setting.color)));
          this.querySelectorAll('[data-effect-key="' + key + '"][data-mode="' + mode + '"]').forEach(button => {
            button.disabled = setting.color === '#000000';
            button.setAttribute('aria-pressed', String(!button.disabled && button.dataset.effectValue === setting.effect));
          });
        });
      });
    }
    setPreset(name) {
      const presets = { meeting: ['hand', 'share'], creator: ['screenshot', 'command'], focus: ['volume-up', 'volume-down'] };
      const pair = presets[name]; if (!pair) return;
      this.querySelector('[data-map="1"]').value = pair[0]; this.querySelector('[data-map="2"]').value = pair[1];
      this.querySelectorAll('[data-preset]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.preset === name)));
      this.syncMappingLabels();
    }
    syncMappingLabels() {
      ['1', '2'].forEach(number => {
        const select = this.querySelector('[data-map="' + number + '"]');
        const label = select.options[select.selectedIndex].text;
        this.querySelector('[data-label="' + number + '"]').textContent = label;
        this.querySelector('[data-device-label="' + number + '"]').textContent = label;
        this.querySelector('[data-action="custom' + number + '"]').title = (number === '1' ? 'One dot: ' : 'Two dots: ') + label;
      });
      this.querySelector('.pg-command-label').hidden = !Array.from(this.querySelectorAll('[data-map]')).some(select => select.value === 'command');
    }
    mark(key) { this.progress.add(key); this.renderProgress(); }
    renderProgress() {
      this.querySelectorAll('[data-challenge]').forEach(item => { item.dataset.done = String(this.progress.has(item.dataset.challenge)); });
      this.querySelector('[data-progress]').textContent = this.progress.size === 5 ? 'Your desk, dialed in. ✓' : 'Explore Click · ' + this.progress.size + '/5';
    }
    renderLight(channel, setting) {
      const level = setting.color === '#000000' ? 0 : setting.effect === 'dim' ? .28 : 1;
      const rgb = [1, 3, 5].map(i => parseInt(setting.color.slice(i, i + 2), 16));
      const peak = Math.max(...rgb);
      const emission = peak === 0 ? '#000000' : '#' + rgb.map(value => Math.round(value * 255 / peak).toString(16).padStart(2, '0')).join('');
      const pad = this.querySelector('.click-demo-pad');
      pad.style.setProperty('--' + channel + '-light', emission);
      this.querySelectorAll('.pg-led-' + channel).forEach(element => {
        element.style.setProperty('--led-opacity', String(level));
        element.style.animation = level > 0 && setting.effect === 'pulse' ? 'pg-led-pulse 1.7s ease-in-out infinite' : 'none';
        if (element.tagName.toLowerCase() === 'stop') element.setAttribute('stop-color', emission);
      });
      const dot = this.querySelector('[data-status-dot="' + channel + '"]');
      dot.style.setProperty('--status-color', setting.color === '#000000' ? '#33393b' : setting.color);
      dot.style.opacity = String(level === 0 ? .6 : Math.max(.3, level));
      dot.style.boxShadow = level === 0 ? 'none' : '';
    }
    endCall() {
      this.inCall = false; this.hand = false; this.sharing = false; this.mic = false; this.camera = false;
      this.render(); this.say('Call complete. Your not-in-a-meeting colors are now active.');
    }
    render() {
      const mode = this.inCall ? 'meeting' : 'idle';
      this.renderLight('mic', this.settings[mode][this.mic ? 'micOn' : 'micOff']);
      this.renderLight('camera', this.settings[mode][this.camera ? 'cameraOn' : 'cameraOff']);
      this.querySelectorAll('[data-settings-mode]').forEach(group => { group.dataset.preview = String(group.dataset.settingsMode === mode); });
      this.querySelector('[data-action="join"]').setAttribute('aria-pressed', String(this.inCall));
      this.querySelector('[data-action="leave"]').setAttribute('aria-pressed', String(!this.inCall));
      [['mic', this.mic], ['camera', this.camera], ['hand', this.hand], ['share', this.sharing]].forEach(([action, state]) => {
        this.querySelectorAll('[data-action="' + action + '"]').forEach(button => {
          button.setAttribute('aria-pressed', String(state)); button.disabled = !this.inCall && !button.classList.contains('click-demo-key');
        });
      });
      this.querySelector('[data-action="end"]').disabled = !this.inCall;
      this.querySelector('[data-mic-status]').textContent = this.mic ? 'Live · click to mute' : 'Muted · click to unmute';
      this.querySelector('[data-camera-status]').textContent = this.camera ? 'On · click to turn off' : 'Off · click to turn on';
      this.querySelector('[data-status="mic"]').textContent = this.mic ? 'Mic live' : 'Mic muted';
      this.querySelector('[data-status="camera"]').textContent = this.camera ? 'Camera on' : 'Camera off';
      this.querySelector('.pg-you-off').hidden = this.camera;
      this.querySelector('[data-you]').classList.toggle('pg-muted', !this.mic);
      this.querySelector('[data-you-mic]').textContent = this.mic ? 'Mic on' : 'Muted';
      this.querySelector('.pg-hand').hidden = !this.hand;
      this.querySelector('.pg-share').hidden = !this.sharing;
      this.querySelector('.pg-tiles').hidden = this.sharing || !this.inCall;
      this.querySelector('.pg-ended').hidden = this.inCall;
      this.querySelector('[data-call-status]').textContent = this.inCall ? '4 people · Demo call' : 'Not in a meeting';
      this.querySelector('.pg-volume span').style.width = this.volume + '%';
      this.querySelector('.pg-volume').setAttribute('aria-valuenow', String(this.volume));
      this.renderProgress();
    }
    runAction(action) {
      if (['hand', 'share', 'end'].includes(action) && !this.inCall) {
        this.say('The demo call has ended. Choose Rejoin demo to keep exploring.'); return;
      }
      switch (action) {
        case 'mic':
          this.mic = !this.mic; this.mark('mic');
          this.say(this.inCall ? (this.mic ? 'You’re live. The floor is yours.' : 'Mic muted. Snack break? We won’t tell.') : (this.mic ? 'Microphone live outside a meeting. Your idle color applies.' : 'Microphone muted outside a meeting. Your idle color applies.')); break;
        case 'camera':
          this.camera = !this.camera; this.mark('camera');
          this.say(this.inCall ? (this.camera ? 'Camera on. Looking sharp.' : 'Camera off. A little off-screen freedom.') : (this.camera ? 'Previewing camera on outside a meeting. Your idle color applies.' : 'Previewing camera off outside a meeting. Your idle color applies.')); break;
        case 'hand':
          this.hand = !this.hand;
          this.say(this.hand ? 'Hand raised. Your next great idea is up.' : 'Hand lowered. Back to the conversation.'); break;
        case 'share':
          this.sharing = !this.sharing; this.mark('share');
          this.say(this.sharing ? 'You’re sharing the demo presentation. Big ideas, one small click.' : 'Screen sharing stopped. Back to the team.'); break;
        case 'end':
          this.endCall(); break;
        case 'screenshot': {
          this.shots += 1; const screen = this.querySelector('.pg-screen');
          screen.classList.remove('pg-flash'); void screen.offsetWidth; screen.classList.add('pg-flash');
          this.later(() => screen.classList.remove('pg-flash'), 450);
          this.toast('Demo screenshot #' + this.shots + ' captured');
          this.say('Demo screenshot captured. That was a keeper.'); break;
        }
        case 'volume-up': case 'volume-down':
          this.volume = Math.max(0, Math.min(100, this.volume + (action === 'volume-up' ? 10 : -10)));
          this.toast('Volume ' + this.volume + '%'); this.say('Demo volume: ' + this.volume + '%. Right where you want it.'); break;
        case 'command': {
          const command = this.querySelector('[data-command]').value.trim() || 'Your custom command';
          this.commands += 1; this.toast(command + ' ✓');
          this.say('Command preview: “' + command + '”. Set up the real action in the MuteMe app.'); break;
        }
      }
      this.render();
    }
  });
})();
